import { LOGIN_ROUTE } from "../evergis/api";

export const redirectToSignIn = () => {
  if (window.location.pathname !== LOGIN_ROUTE) {
    window.history.pushState({ prevUrl: window.location.pathname }, null, LOGIN_ROUTE);
    window.location.reload();
  }
};
